uniform float uTime;
uniform float uSize;
uniform float uPixelRatio;
uniform float uSpinSpeed;

attribute float aScale;
attribute float aOffset; // 個体ごとの明滅位相（0-1）
attribute float aRadius; // 銀河中心からの距離（差動回転・色に使用）

varying float vOffset;
varying float vRadius;

void main()
{
    vec3 pos = position;

    // 差動回転: 内側ほど速く回すと「生きている渦」に見える
    float angle = uTime * uSpinSpeed * (2.2 / (aRadius + 1.5));
    float c = cos(angle);
    float s = sin(angle);
    pos.xy = mat2(c, -s, s, c) * pos.xy;

    vec4 viewPosition = viewMatrix * modelMatrix * vec4(pos, 1.0);
    gl_Position = projectionMatrix * viewPosition;

    // 遠近でサイズを変える
    gl_PointSize = uSize * aScale * uPixelRatio * (1.0 / -viewPosition.z);

    vOffset = aOffset;
    vRadius = aRadius;
}
